// @flow
import React from 'react';
import {DELAY_REFUND_GRAY__24} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';

import type {BadgeShape as Badge} from '../Hit/Hit';

import './CancellationMessage.less';

type Props = {
    freeCancellationBadge: Badge
};

const CancellationMessage = ({freeCancellationBadge}: Props) => {
    return (
        freeCancellationBadge && (
            <div className="CancellationMessage">
                <div className="CancellationMessage_icon">
                    <SVGIcon
                        markup={DELAY_REFUND_GRAY__24}
                        inlineFlex
                        aria-hidden
                    />
                </div>
                <div className="CancellationMessage_text">
                    {freeCancellationBadge.helpText}
                </div>
            </div>
        )
    );
};

export default CancellationMessage;
